<div class="container-fluid">
    <div class="container">
        <div class="left-col-account">
        </div>
        <div class="right-col-account">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>